<template>
  <div class="container-fluid shadow faq-section">
    <div class="row mx-3 py-5">

      <!-- LEFT SIDE -->
      <div class="col-12 col-lg-5 mb-5">
        <div class="text-start mx-3 lh-1">
          <div class="my-md-2">
            <b class="text-white description-xxs text-uppercase">
              {{ $t("message.home1d_Support") }}
            </b>
          </div>

          <span class="text-white description-sm">
            FAQs
          </span>

          <div class="mt-md-3">
            <b class="text-white description-xxs text-uppercase">
              {{ $t("message.home1d_Everything") }}
            </b>
          </div>
        </div>
      </div>

      <!-- RIGHT SIDE (FAQ LIST) -->
      <div class="col-12 col-lg-6 mb-3">
        <div class="text-start mx-3 lh-1">

          <div
            v-for="(faq, index) in faqs"
            :key="index"
            class="faq-item"
          >
            <!-- Question -->
            <div
              class="d-flex justify-content-between align-items-center faq-question"
              @click="toggleFaq(index)"
            >
              <b class="text-white description-xxs text-uppercase my-2">
                {{ $t(faq.q) }}
              </b>

              <img
                :src="down"
                width="22"
                height="22"
                :class="{ rotate: activeIndex === index }"
              />
            </div>

            <!-- Answer -->
            <div v-show="activeIndex === index" class="faq-answer">

            <!-- Paragraph -->
            <p
                v-if="faq.aTitle"
                class="text-white description-xxs mb-2"
            >
                {{ $t(faq.aTitle) }}
            </p>

            <!-- Bullet / Steps -->
            <ul
                v-if="faq.aPoints"
                class="text-white description-xxs ps-3"
            >
                <li
                v-for="(point, i) in $tm(faq.aPoints)"
                :key="i"
                >
                {{ point }}
                </li>
            </ul>

            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref } from "vue"

const down = require("ASSETS/icons/downicon")

// Accordion state
const activeIndex = ref(null)

// FAQ DATA (ONLY ADD HERE)
const faqs = [
  {
    q: "message.faq_question1",
    aTitle: "message.faq_title1",
    aPoints: "message.faq_points1"
  },
  {
    q: "message.faq_question2",
    aTitle: "message.faq_title2",
    aPoints: "message.faq_points2"
  },
  {
    q: "message.faq_question3",
    aTitle: "message.faq_title3",
    aPoints: "message.faq_points3"
  },
  {
    q: "message.faq_question4",
    aTitle: "message.faq_title4",
    aPoints: "message.faq_points4"
  },
  {
    q: "message.faq_question5",
    aTitle: "message.faq_title5",
    aPoints: "message.faq_points5"
  },
  {
    q: "message.faq_question6",
    aTitle: "message.faq_title6",
    aPoints: "message.faq_points6"
  }
]

// Toggle accordion
const toggleFaq = (index) => {
  activeIndex.value = activeIndex.value === index ? null : index
}
</script>

<style scoped>
.faq-section {
  background: #133831;
}

/* FAQ item */
.faq-item {
  border-bottom: 1px solid #ffffff;
  padding: 14px 0;
}

/* Question row */
.faq-question {
  cursor: pointer;
}

/* Answer */
.faq-answer {
  margin-top: 10px;
}

/* Arrow rotation */
.rotate {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

img {
  transition: transform 0.2s ease;
}
.ps-3, .mb-2{
  line-height: 2rem;
  letter-spacing: 1px;
}
</style>
